(function () {
  if (document.documentElement.dataset.zenSliderControlsLoaded === 'true') return;

  document.documentElement.dataset.zenSliderControlsLoaded = 'true';

  var rootSelector = '[data-zen-slider-root]';

  function getRoots(container) {
    var root = container || document;
    var sliders = [];

    if (root.matches && root.matches(rootSelector)) sliders.push(root);

    return sliders.concat(Array.prototype.slice.call(root.querySelectorAll(rootSelector)));
  }

  function getTrackItems(track) {
    return Array.prototype.slice.call(track.children).filter(function (item) {
      return item.getBoundingClientRect().width > 1;
    });
  }

  function getItemGap(track) {
    var styles = window.getComputedStyle(track);

    return parseFloat(styles.columnGap || styles.gap || '18') || 18;
  }

  function getScrollAmount(track) {
    var items = getTrackItems(track);
    var item = items[0];
    var gap = getItemGap(track);

    if (!item) return track.clientWidth;

    var itemStep = item.getBoundingClientRect().width + gap;

    return Math.max(itemStep, track.clientWidth - itemStep);
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function destroySlider(root) {
    if (typeof root.zenSliderControlsCleanup === 'function') {
      root.zenSliderControlsCleanup();
    }
  }

  function initializeSlider(root) {
    if (root.dataset.zenSliderControlsInitialized === 'true') return;

    var track = root.querySelector('[data-zen-slider-track]');
    var controls = root.querySelector('[data-zen-slider-controls]');
    var progress = root.querySelector('[data-zen-slider-progress]');
    var prev = root.querySelector('[data-zen-slider-prev]');
    var next = root.querySelector('[data-zen-slider-next]');

    if (!track || !controls || !progress || !prev || !next) return;

    var frameId = null;
    var timeouts = [];

    function update() {
      frameId = null;

      var maxScroll = track.scrollWidth - track.clientWidth;

      if (maxScroll <= 5) {
        controls.hidden = true;
        prev.disabled = true;
        next.disabled = true;
        progress.style.width = '100%';
        progress.style.left = '0%';
        return;
      }

      var currentScroll = clamp(track.scrollLeft, 0, maxScroll);
      var progressWidth = clamp((track.clientWidth / track.scrollWidth) * 100, 12, 100);
      var progressLeft = (currentScroll / maxScroll) * (100 - progressWidth);

      controls.hidden = false;
      prev.disabled = currentScroll <= 5;
      next.disabled = currentScroll >= maxScroll - 5;
      progress.style.width = progressWidth + '%';
      progress.style.left = progressLeft + '%';
    }

    function requestUpdate() {
      if (frameId !== null) return;
      frameId = window.requestAnimationFrame(update);
    }

    function scrollPrevious() {
      track.scrollBy({
        left: -getScrollAmount(track),
        behavior: 'smooth',
      });
    }

    function scrollNext() {
      track.scrollBy({
        left: getScrollAmount(track),
        behavior: 'smooth',
      });
    }

    track.addEventListener('scroll', requestUpdate, { passive: true });
    prev.addEventListener('click', scrollPrevious);
    next.addEventListener('click', scrollNext);
    window.addEventListener('resize', requestUpdate);

    timeouts.push(window.setTimeout(update, 120));
    timeouts.push(window.setTimeout(update, 650));
    timeouts.push(window.setTimeout(update, 1400));

    root.dataset.zenSliderControlsInitialized = 'true';
    root.zenSliderControlsCleanup = function () {
      track.removeEventListener('scroll', requestUpdate);
      prev.removeEventListener('click', scrollPrevious);
      next.removeEventListener('click', scrollNext);
      window.removeEventListener('resize', requestUpdate);

      if (frameId !== null) {
        window.cancelAnimationFrame(frameId);
      }

      timeouts.forEach(function (timeoutId) {
        window.clearTimeout(timeoutId);
      });

      delete root.dataset.zenSliderControlsInitialized;
      delete root.zenSliderControlsCleanup;
    };
  }

  function initializeSliders(container) {
    getRoots(container).forEach(initializeSlider);
  }

  function destroySliders(container) {
    getRoots(container).forEach(destroySlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeSliders(document);
    });
  } else {
    initializeSliders(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeSliders(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroySliders(event.target);
  });
})();
